<template>
  <el-card shadow="never" :loading="loading">
    <template slot="header">
      <h4>
        Create Refund Request
      </h4>
    </template>
    <el-form>
      <el-form-item label="Amount to be refunded">
        <el-popover trigger="hover">
          <div>
            Maximum Amount: {{ max | currencySign($root.state.facilityData) }}
          </div>
          <el-input-number
            :precision="2"
            :min="0"
            :max="max"
            slot="reference"
            v-model="refundAmount">
          </el-input-number>
        </el-popover>
        <!-- <el-input-number :max="max" v-model="refundAmount">
        </el-input-number> -->
      </el-form-item>
      <el-form-item label="Reason">
        <el-select
          v-model="reason"
          placeholder="Select Reason"
        >
          <el-option
            label="Deposit Refund"
            value="Deposit Refund">
          </el-option>
          <el-option
            label="Overpayment"
            value="Overpayment">
          </el-option>
          <el-option
            label="Other"
            value="Other">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Units/Description">
        <el-input v-model="detail"></el-input>
      </el-form-item>
      <!-- <el-form-item label="Process At">
        <el-alert
          title="This is only for testing on staging env."
          type="warning">
        </el-alert>
        <el-date-picker
            v-model="processAt"
            type="date"
            placeholder="Pick a Processing Date"
          >
          </el-date-picker>
      </el-form-item> -->
      <el-button type="primary" @click="createRefundRequest">Submit</el-button>
    </el-form>
    <!-- <el-table :data="transactions">
      <el-table-column label="Transaction" prop="id">
      </el-table-column>
      <el-table-column label="Type" prop="type" width="120">
      </el-table-column>
      <el-table-column
        label="Amount"
        prop="amount"
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column
        label="In use"
        prop="amountInUse"
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column
        label="Action"
        width="120">
        <template slot-scope="scope">
          <el-button
            @click="() => openRefundRequest(scope.row)" type="text" size="small">Refund Request</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <!-- <el-drawer
      title="Create Refund Request"
      :visible.sync="refundDialog"
      direction="btt"
      append-to-body
      size="65%"
      >
      <el-card shadow="never" v-if="selectedTransaction" :body-style="{ justifyContent: 'center'}" :loading="requestLoading">
        <el-template slot="header">
          <el-alert
            effect="light"
            :closable="false"
            title="This will create a refund request"
            type="warning">
            <p>
              When the request is approved, the refund amount will be refunded to the source payment method.
            </p>
          </el-alert>
        </el-template>
        <el-form>
          <el-form-item label="Amount to be refunded">
            <el-input-number :max="selectedTransaction.amount - selectedTransaction.amountInUse" v-model="refundAmount">
            </el-input-number>
          </el-form-item>
          <el-form-item label="Reason">
            <el-input v-model="detail"></el-input>
          </el-form-item>
        </el-form>
        <el-button :style="{marginLeft: '45%'}" type="primary" @click="createRefundRequest">Submit</el-button>
      </el-card>
    </el-drawer> -->
  </el-card>
</template>

<script>
import axios from 'axios';
import { REFUND_REQUEST_API_BASE, isDevelopment } from '../env';

export default {
  name: 'CustomerPartialRefundRequest',
  props: {
    customer: { type: String, required: true },
    facility: { type: String, required: true },
    wallet: { type: Object, default: () => { } },
  },
  data() {
    return {
      transactions: [],
      loading: false,
      requestLoading: false,
      refundAmount: 0,
      detail: '',
      reason: '',
      processAt: null,
    };
  },
  computed: {
    max() {
      return this.wallet.amountPaid - this.wallet.amount;
    },
    development() {
      return isDevelopment;
    },
  },
  methods: {
    async createRefundRequest() {
      if (this.refundAmount === 0) {
        this.$message.error({
          message: 'Amount can not be 0',
        });
        return;
      }
      this.requestLoading = true;
      const transaction = {
        detail: this.detail,
        reason: this.reason,
        amount: this.refundAmount,
        createdBy: this.$keycloak.tokenParsed.name,
        facility: this.facility,
        customer: this.customer,
        ...(isDevelopment && this.processAt ? {
          processDay: this.processAt.getDate(),
          processMonth: this.processAt.getMonth(),
          processYear: this.processAt.getFullYear(),
        } : {}),
      };

      const response = await axios.post(`${REFUND_REQUEST_API_BASE}/v1/new`, {
        ...transaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.detail = '';
      this.refundAmount = '';
      this.requestLoading = false;

      if (response.data._id) {
        this.$message.success({
          title: 'Success',
          message: 'Refund request initiated.',
        });
      }

      this.$emit('created');
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/CustomerPartialRefundRequest.vue